import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum · Feaststar";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-bg">
      <Nav variant="home" />
      <main className="legal-page" data-testid="impressum-page">
        <div className="max-w-[760px] mx-auto px-5 lg:px-6 pt-28 lg:pt-32 pb-24">
          <Link to="/" className="legal-back" data-testid="legal-back">← Zurück zur Startseite</Link>

          <h1 className="display-md mt-6 mb-8">
            <span className="block italic text-accent">Impressum</span>
          </h1>

          <p className="body-md text-muted mb-10">
            Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)
          </p>

          <section className="legal-section">
            <h2 className="legal-h2">Diensteanbieter</h2>
            <p className="body-md">
              Jessie James Irven<br />
              Greiters 392<br />
              87764 Legau<br />
              Deutschland
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Kontakt</h2>
            <p className="body-md">
              Telefon: <a href="tel:+491718178286" className="legal-link">+49 171 8178286</a><br />
              E-Mail: <a href="mailto:kontakt@feaststar.app" className="legal-link">kontakt@feaststar.app</a>
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Umsatzsteuer-ID</h2>
            <p className="body-md">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <strong>DE449598345</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p className="body-md">
              Jessie James Irven<br />
              Greiters 392<br />
              87764 Legau
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">EU-Streitschlichtung</h2>
            <p className="body-md">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer" className="legal-link">
                https://ec.europa.eu/consumers/odr/
              </a>.<br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="body-md mt-3">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungs­verfahren vor einer Verbraucher­schlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Haftung für Inhalte</h2>
            <p className="body-md">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Haftung für Links</h2>
            <p className="body-md">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="legal-h2">Urheberrecht</h2>
            <p className="body-md">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <p className="body-sm text-muted mt-12">Stand: Juli 2026</p>
        </div>
      </main>
      <Footer variant="home" />
    </div>
  );
}
